import * as $ from 'jquery';
import * as ko from 'knockout';
import Timer = NodeJS.Timer;

declare var DobryKantor: any;
declare var CANTORVERSION: any;
declare var BACKENDPATH: any;

export class CurrencyRatesComponent {
    rates: ko.Observable<any[]>;
    currentPosition: ko.Observable<number>;
    seconds: ko.Observable<number>;
    cantorVersion: ko.Observable<string>;
    hideCurrencyPageLinks: ko.Observable<boolean>;
    reloadTime: number;
    timeout: Timer;

    constructor(params) {
        params = params || {};
        params.hideCurrencyPageLinks = params.hideCurrencyPageLinks || false;

        this.cantorVersion = ko.observable(CANTORVERSION);
        this.hideCurrencyPageLinks = ko.observable(params.hideCurrencyPageLinks);
        this.reloadTime = 15;
        this.currentPosition = ko.observable(0);
        this.rates = ko.observable([]);
        this.seconds = ko.observable(0);
        this.startTimer();
    }

    convert(rates: any[]) {
        let newRates = [];

        for (let rate of rates) {
            newRates.push(ko['mapping'].fromJS(rate));
        }

        return newRates;
    }

    startTimer() {
        if (this.seconds() == 0) {
            this.getCurrencyRates();
            this.seconds(this.reloadTime);
        } else {
            this.seconds(this.seconds() - 1);
        }

        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
            this.startTimer();
        }, 1000);
    }

    getCurrencyRates() {
        return $.getJSON(BACKENDPATH + '/api/currency/rates-with-stationary').then((result) => {
            this.rates(this.convert(result.data));
        });
    }

    getIconClass(data) {
        let result = {};
        result['icon-cur-' + data.Symbol()] = true;
        return result;
    }

    onMoveLeft() {
        if (this.currentPosition() === 0) {
            this.currentPosition(this.rates().length - 4);
        } else {
            this.currentPosition(this.currentPosition() - 4);
        }

        if (this.currentPosition() < 0) {
            this.currentPosition(0);
        }

        $("#currency-rates-container").animate({scrollLeft : this.currentPosition() * ($("#currency-rates-container").children().first().width() + 10)});
    }

    onMoveRight() {
        this.currentPosition(this.currentPosition() + 4);

        if (this.currentPosition() >= this.rates().length - 1) {
            this.currentPosition(0);
        }

        if (this.currentPosition() + 4 > this.rates().length - 1) {
            this.currentPosition(this.rates().length - 4);
        }

        $("#currency-rates-container").animate({scrollLeft : this.currentPosition() * ($("#currency-rates-container").children().first().width() + 10)});
    }

    dispose() {
        clearTimeout(this.timeout);
    }
}
